import { combineReducers } from "redux"
import Auth from "./auth/login/reducer"

const rootReducer = combineReducers({ Auth })

export default rootReducer